// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"031579bf","919":"ed6d913b","956":"e5851925"}[chunkId] + ".chunk.js";
};